import { clsx } from "clsx";

interface SpinnerProps {
  size?: "sm" | "md" | "lg";
  className?: string;
}

// Fixed 100×100 viewBox — scaled via CSS width/height
const STROKE = 8;
const OFFSET = STROKE / 2;
const INNER = 100 - STROKE;
const PERIMETER = 4 * INNER; // 368
const DASH_LEN = Math.round(PERIMETER / 3); // ~123

export function Spinner({ size = "md", className }: SpinnerProps) {
  const sizeClass = { sm: "w-6 h-6", md: "w-10 h-10", lg: "w-16 h-16" }[size];
  return (
    <svg
      viewBox="0 0 100 100"
      className={clsx(sizeClass, "flex-shrink-0", className)}
    >
      <style>{`
        @keyframes flow-around {
          to { stroke-dashoffset: ${-PERIMETER}; }
        }
      `}</style>
      <rect
        x={OFFSET} y={OFFSET}
        width={INNER} height={INNER}
        fill="none"
        stroke="var(--color-border)"
        strokeWidth={STROKE}
      />
      <rect
        x={OFFSET} y={OFFSET}
        width={INNER} height={INNER}
        fill="none"
        stroke="var(--color-primary)"
        strokeWidth={STROKE}
        strokeDasharray={`${DASH_LEN} ${PERIMETER - DASH_LEN}`}
        style={{ animation: "flow-around 1.2s linear infinite" }}
      />
    </svg>
  );
}

export function PageLoader() {
  return (
    <div className="flex items-center justify-center py-16">
      <Spinner size="lg" />
    </div>
  );
}
